import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Notification from './../../components/Notification/';
import actions from './../../data/login/actions';
import { JWTOKEN } from '../../data/constants';
import Logo from './../../components/Logo/';
import { useLanguage } from '../../context/LanguageContext';
import './styles.scss';

class SSO extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: 0,
      pass: '',
      showSnackBar: false
    };
  }
  componentDidMount() {
    const existingToken = JSON.parse(sessionStorage.getItem(JWTOKEN));
    if (existingToken !== null) {
      const { redirect } = this.props;
      redirect('home');
      return;
    }
    this.handleLogin();
  }

  componentDidUpdate() {
    if (this.props.error.loginError === true) {
      this.openSnackBar();
    }
  }
  openSnackBar = () => {
    this.setState({ showSnackBar: true });
  }
  closeSnackBar = () => {
    this.setState({ showSnackBar: false, error: { loginError: false, message: '' } });
  }
  handleLogin = () => {
    const { fetchLoginSSO, location } = this.props;
    localStorage.setItem('loginPath', location.pathname);
    localStorage.setItem('mainLocationIndex', window.history.length - 1);
    fetchLoginSSO();
  }
  render() {
    const login = this.props.labels?.login || {};
    return (
      <main className="Login">
        <section className="Login-Wrapper">
          <Logo />
        </section>
        <footer className="Login-Footer">
          <div>
            <figure>
              <img src="assets/img/IBS_Software_logo.png" alt="" />
            </figure>
          </div>
          <div className="Login-Footer-Disclaimer">
            <span>{login.DISCLAIMER_ITALIC}</span>{login.DISCLAIMER_REGULAR}
          </div>
        </footer>
        <Notification
          open={this.state.showSnackBar}
          message={this.props.error.message}
          closeStatusDisplay={this.closeSnackBar}
        />
      </main>
    );
  }

}

SSO.defaultProps = {
  fetchLogin: function fetchLogin() {},
  fetchLoginSSO: function fetchLoginSSO() {},
  location: {},
  redirect: function redirect() {},
  error: {}
};

SSO.propTypes = {
  fetchLoginSSO: PropTypes.func,
  location: PropTypes.object,
  redirect: PropTypes.func,
  error: PropTypes.shape({
    loginError: PropTypes.bool,
    message: PropTypes.string
  })
};

const mapStateToProps = state => ({ ...state.login });

const mapDispatchToProps = dispatch => ({
  fetchLoginSSO: () => dispatch(actions.fetchLoginSSO()),
  redirect: path => dispatch(actions.redirect(path))
});

const ConnectedSSO = connect(mapStateToProps, mapDispatchToProps)(SSO);

function SSOWrapper(props) {
  const { labels } = useLanguage();
  return <ConnectedSSO {...props} labels={labels} />;
}

export default SSOWrapper;
